import React, { useEffect, useState } from 'react';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import useRotaBase from '../../utils/useRotaBase';

import { Container, SoDesktop, FichaMobileContainer, FichaMobile, CampoFicha } from './styles';
import { TabelaContainer, TabelaVazia, Table, Th, Td, Tr, valorCelula, ehNumero } from '../Tabela/styles';
import GridGenerico from '../GridGenerico';
import Paginacao, { IPaginacao } from '../Paginacao';

// O card do mobile é um resumo (os campos já vêm na ordem do laytel.ordlis); o resto fica na ficha
const MAX_CAMPOS_CARD = 6;

export interface ICampo {
  label: string;
  campo: string;
  /** laytel.pre: casas decimais dos números */
  pre?: string;
}

interface ListaCadastroGenericoProps {
  entidade: string;
  campos: ICampo[];
  dados: Record<string, any>[];
  dadosPaginacao: IPaginacao;
  ordenarPor: string;
  setOrdenarPor: React.Dispatch<React.SetStateAction<string>>;
}

export default function ListaCadastroGenerico({ entidade, campos, dados, dadosPaginacao, ordenarPor, setOrdenarPor }: ListaCadastroGenericoProps) {
  const navigate = useNavigate()
  const rotaBase = useRotaBase();

  const [linhaSelecionada, setLinhaSelecionada] = useState<any>();
  const [mostrarProdutos, setMostrarProdutos] = useState(false);

  const [dadosGridGenerico, setDadosGridGenerico] = useState<Record<string, any>[]>([]);

  const [campoOrdem, sentidoOrdem] = ordenarPor.split(' ');

  function abrirFicha(item: Record<string, any>) {
    navigate(`${rotaBase}/cadastro/${entidade}/${item?.cod ? item.cod : item.codbar}`);
  }

  // Colunas numéricas ficam alinhadas à direita (pelo tipo do valor no primeiro registro)
  const colunaNumerica = (campo: string) => !!dados && dados.length > 0 && ehNumero(dados[0][campo]);

  useEffect(() => {
    if ((entidade === 'vendas' || entidade === 'compras') && (dados && dados.length > 0)) {
      setLinhaSelecionada(dados[0]);
      setMostrarProdutos(true);
    }
  }, [entidade, dados]);

  const semDados = !dados || dados.length === 0;

  return (
    <Container>
      <FichaMobileContainer>
        {semDados && <TabelaVazia>Nenhum registro encontrado</TabelaVazia>}
        {dados && dados.map((item, index) => (
          <FichaMobile key={index} type='button' onClick={() => abrirFicha(item)}>
            {campos.slice(0, MAX_CAMPOS_CARD).map((campo) => (
              <CampoFicha key={campo.campo}>
                <small>{campo.label}</small>
                <strong>{valorCelula(item[campo.campo], campo.pre, campo.campo) || '—'}</strong>
              </CampoFicha>
            ))}
          </FichaMobile>
        ))}
      </FichaMobileContainer>

      <SoDesktop>
        <TabelaContainer>
          <Table>
            <thead>
              <tr>
                {campos.map((campo, index) => {
                  const ordenado = campoOrdem === campo.campo;

                  return (
                    <Th
                      key={index}
                      $ordenavel
                      $ordenado={ordenado}
                      $numero={colunaNumerica(campo.campo)}
                      aria-sort={ordenado ? (sentidoOrdem === 'desc' ? 'descending' : 'ascending') : undefined}
                      onClick={() => setOrdenarPor(`${campo.campo} ${ordenarPor.includes('desc') ? 'asc' : 'desc'}`)}
                    >
                      {campo.label}
                      {ordenado && (sentidoOrdem === 'desc' ? <FaArrowDown size={10} /> : <FaArrowUp size={10} />)}
                    </Th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {dados && dados.map((item, IndexLinha) => (
                <Tr
                  key={IndexLinha}
                  $clicavel
                  $selecionado={item === linhaSelecionada}
                  title='Clique para selecionar, clique de novo para abrir'
                  onClick={() => {
                    if (item === linhaSelecionada) {
                      abrirFicha(item);
                      return;
                    }
                    setLinhaSelecionada(item);
                  }}
                >
                  {campos.map((campo, indexColuna) => (
                    <Td key={indexColuna} $numero={ehNumero(item[campo.campo])}>
                      {valorCelula(item[campo.campo], campo.pre, campo.campo)}
                    </Td>
                  ))}
                </Tr>
              ))}
            </tbody>
          </Table>
          {semDados && <TabelaVazia>Nenhum registro encontrado</TabelaVazia>}
        </TabelaContainer>
      </SoDesktop>

      <Paginacao {...dadosPaginacao} />

      {
        (mostrarProdutos && linhaSelecionada && (entidade === 'vendas' || entidade === 'compras')) &&
        <GridGenerico
          entidade={entidade === 'vendas' ? 'itepedsa' : 'itepeden'}
          codigo={linhaSelecionada.cod}
          dadosGridGenerico={dadosGridGenerico}
          setDadosGridGenerico={setDadosGridGenerico}
        />
      }
    </Container >
  );
};
